export default [
    {
        path: '/news',
        name: 'News',
        component: () => import('../../views/News.vue')
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        props: true,
        component: () => import('../../views/NewsDetail.vue')
    }
]
